import { render, staticRenderFns } from "./TenderArchive.vue?vue&type=template&id=3c323ed2&scoped=true&"
import script from "./TenderArchive.vue?vue&type=script&lang=js&"
export * from "./TenderArchive.vue?vue&type=script&lang=js&"
import style0 from "./TenderArchive.vue?vue&type=style&index=0&id=3c323ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c323ed2",
  null
  
)

export default component.exports